import { useTheme } from "@mui/material";
import LibUtils from "lib/LibUtils";
import { MuiOtpInput, MuiOtpInputProps } from "mui-one-time-password-input";

export interface IMprcPinCodeFieldProps extends Omit<MuiOtpInputProps, "TextFieldsProps"> {
    isNumeric: boolean;
}

export const MprcPinCodeField: React.FC<IMprcPinCodeFieldProps> = (props) => {

    const theme = useTheme();

    return <MuiOtpInput
        {...props}
        validateChar={props.isNumeric ? LibUtils.matchIsNumeric : props.validateChar}
        TextFieldsProps={{
            variant: "outlined",
            sx: {
                backgroundColor: "#EEEEEE",
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: theme.palette.warning.main,
                    },
                    '&:hover fieldset': {
                        borderColor: theme.palette.warning.dark,
                        borderWidth: "2px"
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: theme.palette.warning.main,
                    },
                },
            },
        }}
    />;
};